import { Input } from 'mdb-ui-kit';
import { passwordStrength } from 'check-password-strength';

let one_time_password_form_shown = false;
let one_time_password_lenght = 6;
let otc_form_submited = false;
const standard_login = document.getElementById("standard-login");


// URL Reset 
let current_URL = new URL(window.location.href);
let urlParams = current_URL.searchParams;


if ( current_URL.searchParams.get('action') ) {

    console.log( current_URL, urlParams, urlParams.get('action') );


    if( urlParams.get('action') == 'one-time-password' &&  urlParams.get('email_address') ){

        const targetElement = document.querySelector(".col-login");
        targetElement.innerHTML = ''; // Empty the login div

        const otc_wrapper = document.createElement("div");
            otc_wrapper.classList.add('otc-wrapper')
        targetElement.append( otc_wrapper );  

        create_one_time_code_form( otc_wrapper, urlParams.get('email_address'), '', 'append', urlParams.get('code') );

    }
    if( urlParams.get('action') == 'forgot-password'){

        const targetElement = document.querySelector(".col-login");

        const otc_wrapper = document.createElement("div");
            otc_wrapper.classList.add('otc-wrapper')
        targetElement.append( otc_wrapper );  

        generate_one_time_password_form( otc_wrapper, true );

    }

}


/**
* Add a URL parameter (or changing it if it already exists)
* @param {search} string  this is typically document.location.search
* @param {key}    string  the key to set
* @param {val}    string  value 
*/
var addUrlParam = function(search, key, val){
    var newParam = key + '=' + val,
        params = '?' + newParam;
  
    // If the "search" string exists, then build params from it
    if (search) {
      // Try to replace an existance instance
      params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
  
      // If nothing was replaced, then add the new param to the end
      if (params === search) {
        params += '&' + newParam;
      }
    }
  
    return params;
  };



if( standard_login ){


    const div_standard_error_messages = document.createElement("div");
    div_standard_error_messages.classList.add('error-messages');
    

    const standard_login_introduction = document.getElementById("standard-login-introduction");
    if( standard_login_introduction ){

        insertAfter( div_standard_error_messages, standard_login_introduction );

    } else {

        standard_login.prepend( div_standard_error_messages );  

    }

    // login-introduction

    standard_login.onsubmit = function( event ){

        event.preventDefault();
        event.stopPropagation()

        if ( ! standard_login.checkValidity() ) {

            console.log( standard_login.checkValidity() );

            event.preventDefault()
            event.stopPropagation()
        }

        standard_login.classList.add('was-validated');

        let submit_button = event.target;

        if( standard_login.checkValidity() ){

            // Go to WP and check that the email address exists. 
            grecaptcha.ready(function() {

                grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {

                    let password = document.getElementById("password");
                    let email_address = document.getElementById("email_address");

                    jQuery.ajax({
                        url: theme.ajax,
                        type: 'post',
                        data: {
                            action: 'ajax_login',
                            email_address: email_address.value,
                            password: password.value,
                            token: token,
                        },
                        beforeSend: function(){

                            if( div_standard_error_messages.firstChild ){
                                while(div_standard_error_messages.firstChild && div_standard_error_messages.removeChild(div_standard_error_messages.firstChild));
                            }


                            // Set button to spinner         
                            submit_button.setAttribute('disabled', 'disabled');
                        

                        },
                        success: function( response ) {

                            console.log( response );

                            
                            response = JSON.parse( response );

                            if( response.success ){

                                window.location.replace("/account");


                            } else {


                                let error_message = document.createElement("p");
                                error_message.classList.add('error-message', 'mb-3');
                                
                                let error_message_text = document.createElement("div");
                                error_message_text.innerHTML = response.error_message;
                                error_message.appendChild(error_message_text);

                                div_standard_error_messages.appendChild( error_message );   


                                submit_button.removeAttribute('disabled');


                            }

                        }
                    });

                });

              });

        } 

    }

}








// Forgot Password Form
if( document.getElementById("forgotten-password") ){

    document.getElementById("forgotten-password").onclick = function( e ) {
        generate_one_time_password_form( e, true );
    }

}
// On Click One Time Password Needed 
if( document.getElementById("one-time-password-needed") ){

    document.getElementById("one-time-password-needed").onclick = function( e ) {
        generate_one_time_password_form( e );
    }

}


// One time password form 

function generate_one_time_password_form( e, passwordReset = false ){

    if( e.target ){

        e.preventDefault();

    }

    if( one_time_password_form_shown ){
        return;
    }

    if( standard_login ){
        standard_login.classList.add('d-none');
    }
    document.getElementById("one-time-password-needed").classList.add('d-none');  
    document.getElementById("one-time-password-needed_wrapper").classList.add('d-none');  

    const one_time_password_form = document.createElement("form");
        one_time_password_form.setAttribute('novalidate', 'novalidate');
        one_time_password_form.classList.add('needs-validation');


        const div_error_messages = document.createElement("div");
        div_error_messages.classList.add('error-messages');
        one_time_password_form.append( div_error_messages );  

        const div_introduction = document.createElement("div");
        div_introduction.classList.add('login-introduction');


        if( passwordReset && theme.reset_password_introduction ){

            div_introduction.innerHTML = JSON.parse( theme.reset_password_introduction );

        }
        if( ! passwordReset && theme.create_password_introduction ){

            div_introduction.innerHTML = JSON.parse( theme.create_password_introduction );

        }



        one_time_password_form.append( div_introduction );  





        const div_email_address = document.createElement("div");
            div_email_address.classList.add('form-outline', 'form-white');

            // Create Email
            const input_email_address = document.createElement("input");
                input_email_address.classList.add('form-control', 'form-control-lg' );
                input_email_address.setAttribute('type', 'email');
                input_email_address.setAttribute('id', 'email_address');
                input_email_address.setAttribute('name', 'email_address');
                input_email_address.setAttribute('required', 'required');

            div_email_address.appendChild(input_email_address);

            // Create Email Label
            const label_email_address = document.createElement("label");
                label_email_address.classList.add('form-label');
                label_email_address.setAttribute('for', 'email_address');

                const label_email_address_text = document.createTextNode("Email Address");
                label_email_address.appendChild(label_email_address_text);
            
            div_email_address.appendChild(label_email_address);


            // Create Email Error Label
            const validation_error_email_address = document.createElement("div");
                validation_error_email_address.classList.add('invalid-feedback');

                const validation_error_email_address_text = document.createTextNode("You must provide a valid email address");
                validation_error_email_address.appendChild(validation_error_email_address_text);

            div_email_address.appendChild(validation_error_email_address);



            // Add to form 
            one_time_password_form.appendChild(div_email_address);


            // Create Submit Button
            const div_submit = document.createElement("div");
                div_submit.classList.add('d-grid', 'gap-2');

            const button_submit = document.createElement("button");
                button_submit.setAttribute('type', 'submit');
                button_submit.classList.add('btn', 'btn-lg', 'btn-secondary');

                const button_submit_text = document.createTextNode("Get Authentication Code");
                button_submit.appendChild(button_submit_text);


                div_submit.appendChild(button_submit);

            // Add to form
            one_time_password_form.appendChild(div_submit);

            // Form Validation
            one_time_password_form.onsubmit = function( event ){
                event.preventDefault()
                event.stopPropagation()

                if ( ! one_time_password_form.checkValidity() ) {

                    console.log( one_time_password_form.checkValidity() );

                    event.preventDefault()
                    event.stopPropagation()
                }
        
                one_time_password_form.classList.add('was-validated');

                if( one_time_password_form.checkValidity() ){

                    // Go to WP and check that the email address exists. 


                    grecaptcha.ready(function() {

                        grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {
    

                            jQuery.ajax({
                                url: theme.ajax,
                                type: 'post',
                                data: {
                                    action: 'check_login_email',
                                    email_address: input_email_address.value,
                                    token: token,
                                    password_reset: passwordReset,
                                },
                                beforeSend: function(){

                                    if( div_error_messages.firstChild ){
                                        while(div_error_messages.firstChild && div_error_messages.removeChild(div_error_messages.firstChild));
                                    }
    

                                    // Set button to spinner         
                                    button_submit.setAttribute('disabled', 'disabled');
                                

                                },
                                success: function( response ) {

                                    response = JSON.parse( response );

                                    if( response.success ){

                                        one_time_password_form.classList.add('d-none');

                                        create_one_time_code_form( one_time_password_form, input_email_address.value, response.success_message );


                                    } else {


                                        let error_message = document.createElement("p");
                                        error_message.classList.add('error-message', 'mb-3');
    
                                        let error_message_text = document.createTextNode( response.error_message );
                                        error_message.appendChild(error_message_text);
    
                                        div_error_messages.appendChild( error_message );   


                                        button_submit.removeAttribute('disabled');


                                    }

                                }
                            });
    
                        });
    
                      });

                } 

            }



    // Append Form 
    const targetElement = document.getElementById("one-time-password-needed");
    insertAfter( one_time_password_form, targetElement );

    // Reset JS
    reset_inputs();

    // Remove old button
    e.target.remove();

    // Set form shown.
    one_time_password_form_shown = true;

}






function create_one_time_code_form( current_location, email_address, intro_message = '', insert = 'after', autocode = '' ){

    const otc_form = document.createElement("form");
    otc_form.setAttribute('novalidate', 'novalidate');
    otc_form.setAttribute('name', 'one-time-code');
    otc_form.setAttribute('action', '#');
    otc_form.classList.add('otc',);
    

        let introduction_message = document.createElement("div");
        introduction_message.classList.add( 'login-introduction' );

        if( intro_message ){

            introduction_message.innerHTML = intro_message;

        } else if( theme.one_time_password_introduction ){

            introduction_message.innerHTML = JSON.parse( theme.one_time_password_introduction );
            
        }

        otc_form.appendChild(introduction_message); 


        const div_otc_error_messages = document.createElement("div");
        div_otc_error_messages.classList.add('error-messages');
        otc_form.append( div_otc_error_messages );  

        // Create Fieldset
        const otc_fieldset = document.createElement("fieldset");
        const otc_div = document.createElement("div");


        for (let i = 1; i <= one_time_password_lenght; i++) {

            
            let otc_label = document.createElement("label");
            otc_label.setAttribute('for', 'otc-' + i );
            let otc_label_text = document.createTextNode("Number " + i );
            otc_label.appendChild(otc_label_text);
            otc_fieldset.appendChild(otc_label);


            let otc_input = document.createElement("input");
                otc_input.setAttribute('type', 'number');
                otc_input.setAttribute('pattern', '[0-9]*');
                otc_input.setAttribute('min', '0');
                otc_input.setAttribute('max', '9');
                otc_input.setAttribute('maxlength', '1');
                otc_input.setAttribute('value', '');
                otc_input.setAttribute('inputtype', 'numeric');
                otc_input.setAttribute('id', 'otc-' + i );
                otc_input.setAttribute('required', 'required');

                if( i == 1 ){

                    otc_input.setAttribute('autocomplete', 'one-time-code');

                }

                otc_div.appendChild(otc_input);
        }
        
        otc_fieldset.appendChild(otc_div);
        otc_form.appendChild(otc_fieldset);


        // Create Submit Button
        const otc_div_submit = document.createElement("div");
            otc_div_submit.classList.add('d-grid', 'gap-2');

        const otc_button_submit = document.createElement("button");
            otc_button_submit.setAttribute('type', 'submit');
            otc_button_submit.classList.add('btn', 'btn-lg', 'btn-secondary');

            const otc_button_submit_text = document.createTextNode("Submit");
            otc_button_submit.appendChild(otc_button_submit_text);


            otc_div_submit.appendChild(otc_button_submit);

        // Add to form
        otc_form.appendChild(otc_div_submit);

        // Insert After 

        if( insert == 'after'){

            insertAfter( otc_form, current_location );

        } else {

            current_location.appendChild(otc_form);

        }
        
        // One Time Password
        one_time_password( otc_form );


        // 

        if( autocode ){

            let first_field = document.querySelectorAll('.otc input[type="number"]')[0];
            first_field.value = autocode;

            // Create a new 'change' event
            var event = new Event('input');

            // Dispatch it.
            first_field.dispatchEvent(event);                    
        
        }


        otc_form.onsubmit = function( event ){
            

            event.preventDefault();
            event.stopPropagation();

            if( otc_form_submited ){
                return;
            }


            if ( ! otc_form.checkValidity() ) {

                otc_form_submited = false;

            } 
        
            if ( otc_form.checkValidity() ) {

                otc_form_submited = true;

                // Check the code. 

                let code = '';

                for (var i = 1; i < otc_form.elements.length; i++) {

                    code += otc_form.elements[i].value;

                }

                // Google Recaptcha 

                grecaptcha.ready(function() {

                    grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {


                        jQuery.ajax({
                            url: theme.ajax,
                            type: 'post',
                            data: {
                                action: 'one_time_code_check',
                                email_address: email_address,
                                code: code,
                                token: token,
                            },
                            beforeSend: function(){

                                if( div_otc_error_messages.firstChild ){
                                    while(div_otc_error_messages.firstChild && div_otc_error_messages.removeChild(div_otc_error_messages.firstChild));
                                }

                                // Set button to spinner         
                                otc_button_submit.setAttribute('disabled', 'disabled');
                            
                            },
                            success: function( response ) {

                                response = JSON.parse( response );

                                console.log( response );

                                if( response.success ){


                                    otc_form.classList.add('d-none');

                                    if( response.password_reset_needed ){

                                        generate_password_needed( otc_form, email_address, response.first_login );

                                    } else {

                                        // Redirect as they are now loggedin
                                        window.location.replace("/account/tickets/");

                                    }

                                } else {


                                    let error_message = document.createElement("p");
                                    error_message.classList.add('error-message', 'mb-3');

                                    let error_message_text = document.createTextNode( response.error_message );
                                    error_message.appendChild(error_message_text);

                                    div_otc_error_messages.appendChild( error_message );   


                                    otc_button_submit.removeAttribute('disabled');

                                    otc_form_submited = false;


                                }

                            }
                        });

                    });

                  });
            }

        }

}



// create function, it expects 2 values.
function insertAfter(newElement,targetElement) {
    // target is what you want it to go after. Look for this elements parent.
    var parent = targetElement.parentNode;

    // if the parents lastchild is the targetElement...
    if (parent.lastChild == targetElement) {
        // add the newElement after the target element.
        parent.appendChild(newElement);
    } else {
        // else the target has siblings, insert the new element between the target and it's next sibling.
        parent.insertBefore(newElement, targetElement.nextSibling);
    }
}

function one_time_password( form ){


    let ins = document.querySelectorAll('.otc input[type="number"]');
    let first = ins[0]; 
    let last = ins[ins.length - 1]; 

    // Focus First 
    first.focus();


    let splitNumber = function(e) {
        let data = e.data || e.target.value; // Chrome doesn't get the e.data, it's always empty, fallback to value then.
        if ( ! data ) return; // Shouldn't happen, just in case.
        if ( data.length === 1 ) return; // Here is a normal behavior, not a paste action.
        
        popuNext(e.target, data);
        //for (i = 0; i < data.length; i++ ) { ins[i].value = data[i]; }
    };

    let popuNext = function(el, data) {
        el.value = data[0]; // Apply first item to first input

        // Create a new 'change' event
        var event = new Event('change');

        // Dispatch it.
        el.dispatchEvent(event);

        data = data.substring(1); // remove the first char.
        if ( el.nextElementSibling && data.length ) {
            // Do the same with the next element and next data
            popuNext(el.nextElementSibling, data);
        }
    };

    let lastNumber = function(e){


        // Create a new 'submit' event
        var event = new Event('submit');

        // Dispatch it on the form in question.
        form.dispatchEvent(event);

    };

    ins.forEach(function(input) {
        /**
         * Control on keyup to catch what the user intent to do.
         * I could have check for numeric key only here, but I didn't.
         */
        input.addEventListener('keyup', function(e){
            // Break if Shift, Tab, CMD, Option, Control.
            if (e.keyCode === 16 || e.keyCode == 9 || e.keyCode == 224 || e.keyCode == 18 || e.keyCode == 17) {
                return;
            }
            
            // On Backspace or left arrow, go to the previous field.
            if ( (e.keyCode === 8 || e.keyCode === 37) && this.previousElementSibling && this.previousElementSibling.tagName === "INPUT" ) {
                this.previousElementSibling.select();
            } else if (e.keyCode !== 8 && this.nextElementSibling) {
                this.nextElementSibling.select();
            }
            
            // If the target is populated to quickly, value length can be > 1
            if ( e.target.value.length > 1 ) {
                splitNumber(e);
            }
        });
        
        /**
         * Better control on Focus
         * - don't allow focus on other field if the first one is empty
         * - don't allow focus on field if the previous one if empty (debatable)
         * - get the focus on the first empty field
         */
        input.addEventListener('focus', function(e) {

            // If the focus element is the first one, do nothing
            if ( this === first ) return;
            
            // If value of input 1 is empty, focus it.
            if ( first.value === '' ) {
                first.focus();
            }
            
            // If value of a previous input is empty, focus it.
            // To remove if you don't wanna force user respecting the fields order.
            if ( this.previousElementSibling.value == '' ) {
                this.previousElementSibling.focus();
            }

        });
    });

    /**
     * Handle copy/paste of a big number.
     * It catches the value pasted on the first field and spread it into the inputs.
     */
     first.addEventListener('input', splitNumber);
     last.addEventListener('change', lastNumber);


}
function reset_inputs(){


    document.querySelectorAll('.form-outline').forEach((input) => {

        new Input( input ).init();
        

    });
}

function generate_password_needed( location, email_address, first_login = false) {


    const ftp_form = document.createElement("form");
    ftp_form.setAttribute('novalidate', 'novalidate');
    ftp_form.setAttribute('name', 'add-a-password');
    ftp_form.setAttribute('action', '#');
    ftp_form.classList.add('add-a-password');



    let introduction_message = document.createElement("div");
    introduction_message.classList.add( 'login-introduction' );


        if( first_login && theme.set_password_introduction_first_time ){

            introduction_message.innerHTML = JSON.parse( theme.set_password_introduction_first_time );

        }
        if( ! first_login && theme.set_password_introduction ){

            introduction_message.innerHTML = JSON.parse( theme.set_password_introduction );

        }

    ftp_form.appendChild(introduction_message); 

    




    const div_ftp_password = document.createElement("div");
        div_ftp_password.classList.add('form-outline', 'form-white');

        const div_error_messages = document.createElement("div");
        div_error_messages.classList.add('error-messages');
        div_ftp_password.append( div_error_messages );  

        // Create Password
        const input_ftp_password = document.createElement("input");
            input_ftp_password.classList.add('form-control', 'form-control-lg');
            input_ftp_password.setAttribute('type', 'password');
            input_ftp_password.setAttribute('id', 'ftp_password');
            input_ftp_password.setAttribute('name', 'password');
            input_ftp_password.setAttribute('required', 'required');

        div_ftp_password.appendChild(input_ftp_password);

        // Create Password Label
        const label_ftp_password = document.createElement("label");
            label_ftp_password.classList.add('form-label');
            label_ftp_password.setAttribute('for', 'email_address');

            const label_ftp_password_text = document.createTextNode("Password");
            label_ftp_password.appendChild(label_ftp_password_text);
        
        div_ftp_password.appendChild(label_ftp_password);


    const div_ftp_password_contains = document.createElement("div");
        div_ftp_password_contains.classList.add('d-grid', 'gap-2');


        const div_ftp_password_contains_ul = document.createElement("ul");
              div_ftp_password_contains_ul.classList.add('ftp_includes', 'list-group', 'mb-2');




            let password_contains_array = ['lowercase', 'uppercase', 'symbol', 'number', "8+"];

            password_contains_array.forEach( element => { 
                
                
                let li = document.createElement("li");
                    li.classList.add('list-group-item');
                    li.setAttribute('id', 'ftp_' + element );

                let text = document.createTextNode( element.charAt(0).toUpperCase() + element.slice(1) + " Character");
                    li.appendChild(text);

                div_ftp_password_contains_ul.appendChild(li);                                                
            
            });



    div_ftp_password_contains.appendChild(div_ftp_password_contains_ul);



    ftp_form.appendChild(div_ftp_password);
    ftp_form.appendChild(div_ftp_password_contains);


    // Submit 
    let otc_div_submit = document.createElement("div");
    otc_div_submit.classList.add('d-grid', 'gap-2');

    let otc_button_submit = document.createElement("button");
        otc_button_submit.setAttribute('id', 'ftp_submit');
        otc_button_submit.setAttribute('type', 'submit');
        otc_button_submit.setAttribute('disabled', true);
        otc_button_submit.classList.add('btn', 'btn-lg', 'btn-secondary', 'disabled');

        const otc_button_submit_text = document.createTextNode("Set Password");
        otc_button_submit.appendChild(otc_button_submit_text);


        otc_div_submit.appendChild(otc_button_submit);

    // Add to form
    ftp_form.appendChild(otc_div_submit);




    insertAfter( ftp_form, location );
    reset_inputs();



    input_ftp_password.addEventListener('keyup', function( event ){

        // Create a new 'submit' event
        var event = new Event('change');

        // Dispatch it on the form in question.
        input_ftp_password.dispatchEvent(event);

    });

    let submit_button_created = false;

    input_ftp_password.addEventListener('change', function( event ){

        let strength = passwordStrength( event.target.value );
        let contains = strength.contains;


        if( contains.includes("lowercase") ){

            // Include the class
            document.getElementById("ftp_lowercase").classList.add("included");

        } else {

            // Remove the class
            document.getElementById("ftp_lowercase").classList.remove("included");

        }

        if( contains.includes("uppercase") ){

            // Include the class
            document.getElementById("ftp_uppercase").classList.add("included");

        } else {

            // Remove the class
            document.getElementById("ftp_uppercase").classList.remove("included");

        }

        if( contains.includes("symbol")  ){


            // Include the class
            document.getElementById("ftp_symbol").classList.add("included");

        } else {

            // Remove the class
            document.getElementById("ftp_symbol").classList.remove("included");

        }

        if( contains.includes("number") ){

            // Include the class
            document.getElementById("ftp_number").classList.add("included");

        } else {

            // Remove the class
            document.getElementById("ftp_number").classList.remove("included");

        }

        if( strength.length >= 8  ){

            // Include the class
            document.getElementById("ftp_8+").classList.add("included");

        } else {

            // Remove the class
            document.getElementById("ftp_8+").classList.remove("included");

        }

        if( strength.length >= 8 && contains.length == 4   ){

            otc_button_submit.removeAttribute('disabled');
            otc_button_submit.classList.remove('disabled');

        } else {

            otc_button_submit.setAttribute('disabled','true');
            otc_button_submit.classList.add('disabled');

        }

    });

    ftp_form.onsubmit = function( event ){

        event.preventDefault()
        event.stopPropagation()

        let submit = document.getElementById('ftp_submit');

        grecaptcha.ready(function() {

            grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {


                jQuery.ajax({
                    url: theme.ajax,
                    type: 'post',
                    data: {
                        action: 'set_new_password',
                        password: input_ftp_password.value,
                        email_address: email_address,
                        token: token,
                    },
                    beforeSend: function(){

                        // Set button to spinner         
                        submit.setAttribute('disabled', 'disabled');
                    

                    },
                    success: function( response ) {

                        response = JSON.parse( response );

                        console.log( response );

                        if( response.success ){

                            window.location.replace("/account/tickets/");


                        } else {


                            submit.removeAttribute('disabled');

                        }

                    }
                });

            });

          });

    }

}